// extracted by mini-css-extract-plugin
export default {"wrapper":"categoryDropdown_wrapper__jLdTs","popperContainer":"categoryDropdown_popperContainer__M4-bL","treePaper":"categoryDropdown_treePaper__f64uI"};